import React from "react";
import "../../App.css";
const AboutSlider = (props) => {
  return (
    <div className={`slider-sec`}>
      <div className="coma-container">
        <div className="coma">
          <img
            src={require("../../Assets/img/coma.png")}
            className="img-fluid"
            alt="coma"
          />
        </div>
        <img
          src={props.image}
          className="img-fluid author-image"
          alt="author"
        />
      </div>
      <div className="slider-txt">
        <p className="std-p">{props.paragraph}</p>
        <div className="slidertxt-arrow">
          <div className="slider-txt-sm">
            <h3 className="gradient-txt f-22 text-left">
              {props.firstname} <span>{props.lastname}</span>
            </h3>
            <p className="std-p">{props.designation}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutSlider;
